import { Link } from "@/lib/nav";

/**
 * 標誌：俯視角度的客機剪影，與 public/favicon.svg 是同一條路徑。
 * 兩邊要一起改，不然分頁列的圖示會跟頁首對不上。
 * 用 currentColor 讓它跟著文字顏色走（深色底也能用）。
 */
export function PlaneMark({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true" className={className} fill="currentColor">
      <path d="M16 5.2c1.02 0 1.85 1.06 1.85 2.37v5.24l9.15 5.66v2.29l-9.15-2.4v4.4l2.62 1.9v1.55L16 25.4l-4.47.81v-1.55l2.62-1.9v-4.4l-9.15 2.4v-2.29l9.15-5.66V7.57C14.15 6.26 14.98 5.2 16 5.2Z" />
    </svg>
  );
}

/** 每頁共用的頁首：極簡 wordmark + 頁面說明 */
export function BoardHeader({ sub }: { sub?: string }) {
  return (
    <header className="mb-6 flex items-center justify-between pt-2">
      <Link href="/" className="flex items-center gap-1.5 text-[17px] font-bold tracking-tight">
        <PlaneMark className="text-accent h-[18px] w-[18px]" />
        Dinner Air
      </Link>
      <span className="text-sub max-w-[60%] truncate text-[13px]">{sub ?? "聚餐報名"}</span>
    </header>
  );
}

export function BoardShell({ children, wide = false }: { children: React.ReactNode; wide?: boolean }) {
  return (
    <main className={`mx-auto min-h-screen px-4 pb-10 pt-4 sm:px-6 ${wide ? "max-w-5xl" : "max-w-xl"}`}>
      {children}
    </main>
  );
}

export function SectionTitle({ en, zh }: { en: string; zh: string }) {
  return (
    <h2 className="mb-3 flex items-baseline gap-2">
      <span className="text-[20px] font-bold">{zh}</span>
      <span className="text-sub text-[12px] font-medium tracking-wide">{en}</span>
    </h2>
  );
}

export function Loading() {
  return <div className="card text-sub px-4 py-12 text-center text-[14px]">載入中…</div>;
}

export function NotFoundBoard({ message, backHref = "/", backLabel = "返回航班列表" }: {
  message: string;
  backHref?: string;
  backLabel?: string;
}) {
  return (
    <div className="card flex flex-col items-center gap-4 px-6 py-14 text-center">
      <span className="text-[40px]">🛫</span>
      <p className="text-[17px] font-semibold">找不到這個頁面</p>
      <p className="text-sub -mt-2 text-[14px]">{message}</p>
      <Link href={backHref} className="btn btn-secondary text-[14px]">
        ← {backLabel}
      </Link>
    </div>
  );
}
